"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Link } from "@opensea/next-ui-kit";
import { AccountCircle } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { getProfileUrlByIdentifier } from "@/components/profile/utils";
import { useAddress } from "@/hooks/wallet";
import { MoreMenuItem, MoreMenuItemAvatar, MoreMenuItemContent, MoreMenuItemTitle } from "./MoreMenuItem";
export function MoreMenuProfileItem(t0) {
  const $ = _c(21);
  let isSheet;
  let onClick;
  let rest;
  if ($[0] !== t0) {
    ({
      isSheet,
      onClick,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isSheet;
    $[2] = onClick;
    $[3] = rest;
  } else {
    isSheet = $[1];
    onClick = $[2];
    rest = $[3];
  }
  const address = useAddress();
  const t = useTranslations("MoreMenuProfileItem");
  let t1;
  if ($[4] !== address) {
    t1 = getProfileUrlByIdentifier(address);
    $[4] = address;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== isSheet) {
    t2 = isSheet ? <Button icon={AccountCircle} size="lg" variant="secondary" /> : <MoreMenuItemAvatar icon={AccountCircle} />;
    $[6] = isSheet;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t) {
    t3 = t("title");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <MoreMenuItemContent><MoreMenuItemTitle>{t3}</MoreMenuItemTitle></MoreMenuItemContent>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== isSheet || $[13] !== rest || $[14] !== t2 || $[15] !== t4) {
    t5 = <MoreMenuItem isSheet={isSheet} {...rest}>{t2}{t4}</MoreMenuItem>;
    $[12] = isSheet;
    $[13] = rest;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== onClick || $[18] !== t1 || $[19] !== t5) {
    t6 = <Link href={t1} onClick={onClick} variant="unstyled">{t5}</Link>;
    $[17] = onClick;
    $[18] = t1;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}